import { ObjectId, NodeState } from './engine.nodes.state.model';
import { Patch } from 'src/vendor/immer-6.0.9/compat/pre-3.7/dist/immer';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';

export namespace NodeActions {

  export class Reset {
    static readonly type = '[Engine Nodes] Reset';
    constructor() {}
  }

  export class InitNodeState {
    static readonly type = '[Engine Nodes] init nodes';
    constructor(
      public nodeState: Record<string, Record<ObjectId, NodeState>>
    ) {}
  }

  export class ApplyPatch {
    static readonly type = '[Engine Nodes] patch nodes';
    constructor(public patches: Patch[]) {}
  }

  export class SetActiveChapter {
    static readonly type = '[Engine Nodes] set active chapter';
    constructor(public activeChapterId: string) {}
  }

  export class DuplicateNodeState {
    static readonly type = '[Engine Nodes] Duplicate node state';
    constructor(
      public originalChapterId: string,
      public copyChapterId: string
    ) {}
  }


  export class UpdateNodesShown {
    static readonly type = '[Engine Nodes] update nodes shown';
    constructor(
      public show: boolean,
      public objectIds?: ObjectId[],
      public patch?: Record<ObjectId, boolean>,
      public record: boolean = true,
      public setByTween: boolean = false
    ) {}
  }

  export class UpdateNodeSelected {
    static readonly type = '[Engine Nodes] update nodes selected';
    constructor(public objectId?: ObjectId) {}
  }

  export class UpdateNodesChecked {
    static readonly type = '[Engine Nodes] update nodes checked';
    constructor(
      public checked: boolean,
      public objectIds?: ObjectId[],
      public patch?: Record<ObjectId, boolean>
    ) {}
  }

  export class UpdateNodesPickable {
    static readonly type = '[Engine Nodes] update nodes pickable';
    constructor(public pickable: boolean,
      public objectIds?: ObjectId[],
      public patch?: Record<ObjectId, boolean>
    ) {}
  }

  export class UpdateNodesPaint {
    static readonly type = '[Engine Nodes] update nodes paint';
    constructor(
      public recipe: ColorRecipeModel,
      public objectIds?: ObjectId[],
      public patch?: Record<ObjectId, ColorRecipeModel>,
      public record: boolean = true
    ) {}
  }

}
